import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { FaEdit, FaTimes } from "react-icons/fa";
import "@github/relative-time-element";
import ScrollToTop from "../../../../components/scrollToTop/scrollToTop";
import { Helmet } from "react-helmet";
import ReactTimeAgo from "react-time-ago";
import ReactDOMServer from "react-dom/server";
import "@formatjs/intl-relativetimeformat/polyfill";
import "@formatjs/intl-relativetimeformat/locale-data/es"; // Importa todos los locales que necesites (por ejemplo, 'es' para español)
import "./cooler_users.css";
import DeletedCoolerUsers from "./deleted-cooler-users";

function CoolerUsers({ handleMenuClick }) {
  const [entries, setEntries] = useState([]);
  const [updateTrigger, setUpdateTrigger] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [dataPerPage, setDataPerPage] = useState(10);
  const [loading, setLoading] = useState(true);
  const [searchValue, setSearchValue] = useState("");
  const [showDeleted, setShowDeleted] = useState(false);

  const filteredData = searchValue
    ? entries.filter(
        (data) =>
          data.first_name.toUpperCase().includes(searchValue.toUpperCase()) ||
          data.middle_name.toUpperCase().includes(searchValue.toUpperCase()) ||
          data.last_name.toUpperCase().includes(searchValue.toUpperCase()) ||
          data.number.toUpperCase().includes(searchValue.toUpperCase())
      )
    : entries;

  const indexOfLastData = currentPage * dataPerPage;
  const indexOfFirstData = indexOfLastData - dataPerPage;

  const currentData = filteredData.slice(indexOfFirstData, indexOfLastData);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const totalPageCount = Math.ceil(filteredData.length / dataPerPage);
  const pageNumbers = [];
  const maxPageNumbersToShow = 20;

  let startPage, endPage;
  if (totalPageCount <= maxPageNumbersToShow) {
    startPage = 1;
    endPage = totalPageCount;
  } else {
    startPage = Math.max(1, currentPage - Math.floor(maxPageNumbersToShow / 2));
    endPage = Math.min(totalPageCount, startPage + maxPageNumbersToShow - 1);

    if (endPage - startPage < maxPageNumbersToShow) {
      startPage = endPage - maxPageNumbersToShow + 1;
    }
  }

  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(i);
  }

  const showEntries = (e) => {
    setDataPerPage(e.target.value);
  };

  const getEntries = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND}/api/v1/cooler_users`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      if (res.data.code === 1) {
        setEntries(res.data.data);
        setLoading(false);
      } else {
        Swal.fire("Error", "Hubo un error al obtener los datos", "error");
        setLoading(false);
      }
    } catch (error) {
      Swal.fire("Error", "Hubo un error al obtener los datos", "error");
      setLoading(false);
    }
  };

  const deleteEntries = async (id) => {
    try {
      const result = await Swal.fire({
        title: "¿Estás seguro?",
        text: "¡No podrás revertir esto!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, eliminarlo",
        cancelButtonText: "No, cancelar",
        reverseButtons: true,
        buttonsStyling: true,
      });
      if (result.isConfirmed) {
        await axios.delete(
          `${process.env.REACT_APP_URL_BACKEND}/api/v1/cooler_users/delete/${id}`,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          }
        );
        Swal.fire("¡Eliminado!", "El usuario ha sido eliminado.", "success");
        setUpdateTrigger(!updateTrigger);
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Cancelado");
      }
    } catch (error) {
      Swal.fire("Error", "Hubo un error", "error");
    }
  };

  const REQUIRED_FIELDS = [
    "first_name",
    "middle_name",
    "last_name",
    "number",
    "area",
    "is_coordinator",
  ];

  const markError = (id) => {
    const el = document.getElementById(id);
    if (el) el.classList.add("input-error");
  };

  const clearError = (id) => {
    const el = document.getElementById(id);
    if (el) el.classList.remove("input-error");
  };

  const attachLiveValidation = () => {
    REQUIRED_FIELDS.forEach((id) => {
      const el = document.getElementById(id);
      if (!el) return;

      el.addEventListener("input", () => {
        if (el.value.trim() !== "") clearError(id);
      });

      el.addEventListener("change", () => {
        if (el.value.trim() !== "") clearError(id);
      });
    });
  };

  const updateEntries = async (id) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND}/api/v1/cooler_users/${id}`,
        null,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      const entryData = response.data.data; // Accediendo a los datos correctos

      // const result = await Swal.fire({
      //   title: "Editar usuario",
      //   html:
      //     `<div class="form-grid">` +
      //     `<input type="text" id="first_name" class="swal2-input" placeholder="Nombre" value="${entryData.first_name}" oninput="this.value = this.value.replace(/[^a-zA-Z ]/g, '')">` +
      //     `<input type="text" id="middle_name" class="swal2-input" placeholder="Apellido paterno" value="${entryData.middle_name}" oninput="this.value = this.value.replace(/[^a-zA-Z ]/g, '')">` +
      //     `<input type="text" id="last_name" class="swal2-input" placeholder="Apellido materno" value="${entryData.last_name}" oninput="this.value = this.value.replace(/[^a-zA-Z ]/g, '')">` +
      //     `<input type="text" id="number" class="swal2-input" placeholder="Número de empleado" value="${entryData.number}" oninput="this.value = this.value.replace(/[^a-zA-Z0-9]/g, '')">` +
      //     `<select id="is_coordinator" class="swal2-input">` +
      //     `<option value="1" ${entryData.is_coordinator == 1 ? 'selected' : ''}>Sí</option>` +
      //     `<option value="0" ${entryData.is_coordinator == 0 ? 'selected' : ''}>No</option>` +
      //     `</select>` +
      //     `</div>`,
      //   showCancelButton: true,
      //   confirmButtonText: "Actualizar",
      //   cancelButtonText: "Cancelar",
      //   preConfirm: function () {
      //     const first_name = document.getElementById("first_name").value;
      //     const middle_name = document.getElementById("middle_name").value;
      //     const last_name = document.getElementById("last_name").value;
      //     const number = document.getElementById("number").value;
      //     const is_coordinator = document.getElementById("is_coordinator").value;

      //     if (!first_name || !middle_name || !last_name || !number || is_coordinator === null) {
      //       Swal.showValidationMessage("Todos los campos son obligatorios");
      //       return false;
      //     }

      //     return {
      //       first_name,
      //       middle_name,
      //       last_name,
      //       number,
      //       is_coordinator
      //     };
      //   },
      // });
      const reactComponentHtml = ReactDOMServer.renderToString(
        <>
          <form
            acceptCharset="UTF-8"
            id="formValidation"
            className="form-horizontal fv-form fv-form-bootstrap"
            autoComplete="off"
            encType="multipart/form-data"
            noValidate="novalidate"
          >
            <div className="row mb-3 text-start">
              <div className="col-md-6">
                <label htmlFor="first_name">Nombre *</label>
                <input
                  type="text"
                  className="form-control"
                  id="first_name"
                  placeholder="Nombre"
                  value={entryData[0].first_name}
                />
              </div>
              <div className="col-md-6">
                <label htmlFor="middle_name">Apellido paterno *</label>
                <input
                  type="text"
                  className="form-control"
                  id="middle_name"
                  placeholder="Nombre"
                  value={entryData[0].middle_name}
                />
              </div>
              <div className="col-md-6">
                <label htmlFor="last_name">Apellido materno *</label>
                <input
                  type="text"
                  className="form-control"
                  id="last_name"
                  placeholder="Nombre"
                  value={entryData[0].last_name}
                />
              </div>
              <div className="col-md-6">
                <label htmlFor="number">Número de empleado *</label>
                <input
                  type="text"
                  className="form-control"
                  id="number"
                  placeholder="Número de empleado"
                  value={entryData[0].number}
                />
              </div>
              <div className="col-md-6">
                <label htmlFor="area">Área *</label>
                <select
                  className="form-select"
                  id="area"
                  // value={entryData[0].area}
                >
                  <option value="">Selecciona...</option>
                  <option value="1" selected={entryData[0].area == 1}>Importación</option>
                  <option value="2" selected={entryData[0].area == 2}>Exportación</option>
                </select>
              </div>
              <div className="col-md-6">
                <label htmlFor="is_coordinator">¿Es coordinador? *</label>
                <select
                  className="form-select"
                  id="is_coordinator"
                  // value={entryData[0].is_coordinator}
                >
                  <option value="">Selecciona...</option>
                  <option value="1" selected={entryData[0].is_coordinator == 1}>Sí</option>
                  <option value="0" selected={entryData[0].is_coordinator == 0}>No</option>
                </select>
              </div>
            </div>

            <table className="table table-bordered">
              <thead className="thead-dark">
                <tr>
                  <th>Horario/Día</th>
                  <th>Lunes</th>
                  <th>Martes</th>
                  <th>Miércoles</th>
                  <th>Jueves</th>
                  <th>Viernes</th>
                  <th>Sábado</th>
                  <th>Domingo</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>De:</td>
                  <td>
                    <input
                      id="monday_start"
                      type="time"
                      className="form-control"
                      value={entryData[0].monday_start}
                    />
                  </td>
                  <td>
                    <input
                      id="tuesday_start"
                      type="time"
                      className="form-control"
                      value={entryData[0].tuesday_start}
                    />
                  </td>
                  <td>
                    <input
                      id="wednesday_start"
                      type="time"
                      className="form-control"
                      value={entryData[0].wednesday_start}
                    />
                  </td>
                  <td>
                    <input
                      id="thursday_start"
                      type="time"
                      className="form-control"
                      value={entryData[0].thursday_start}
                    />
                  </td>
                  <td>
                    <input
                      id="friday_start"
                      type="time"
                      className="form-control"
                      value={entryData[0].friday_start}
                    />
                  </td>
                  <td>
                    <input
                      id="saturday_start"
                      type="time"
                      className="form-control"
                      value={entryData[0].saturday_start}
                    />
                  </td>
                  <td>
                    <input
                      id="sunday_start"
                      type="time"
                      className="form-control"
                      value={entryData[0].sunday_start}
                    />
                  </td>
                </tr>
                <tr>
                  <td>Inicio de comida:</td>
                  <td>
                    <input
                      id="monday_start_food"
                      type="time"
                      className="form-control"
                      value={entryData[0].monday_start_food}
                    />
                  </td>
                  <td>
                    <input
                      id="tuesday_start_food"
                      type="time"
                      className="form-control"
                      value={entryData[0].tuesday_start_food}
                    />
                  </td>
                  <td>
                    <input
                      id="wednesday_start_food"
                      type="time"
                      className="form-control"
                      value={entryData[0].wednesday_start_food}
                    />
                  </td>
                  <td>
                    <input
                      id="thursday_start_food"
                      type="time"
                      className="form-control"
                      value={entryData[0].thursday_start_food}
                    />
                  </td>
                  <td>
                    <input
                      id="friday_start_food"
                      type="time"
                      className="form-control"
                      value={entryData[0].friday_start_food}
                    />
                  </td>
                  <td>
                    <input
                      id="saturday_start_food"
                      type="time"
                      className="form-control"
                      value={entryData[0].saturday_start_food}
                    />
                  </td>
                  <td>
                    <input
                      id="sunday_start_food"
                      type="time"
                      className="form-control"
                      value={entryData[0].sunday_start_food}
                    />
                  </td>
                </tr>
                <tr>
                  <td>Fin de comida:</td>
                  <td>
                    <input
                      id="monday_finish_food"
                      type="time"
                      className="form-control"
                      value={entryData[0].monday_finish_food}
                    />
                  </td>
                  <td>
                    <input
                      id="tuesday_finish_food"
                      type="time"
                      className="form-control"
                      value={entryData[0].tuesday_finish_food}
                    />
                  </td>
                  <td>
                    <input
                      id="wednesday_finish_food"
                      type="time"
                      className="form-control"
                      value={entryData[0].wednesday_finish_food}
                    />
                  </td>
                  <td>
                    <input
                      id="thursday_finish_food"
                      type="time"
                      className="form-control"
                      value={entryData[0].thursday_finish_food}
                    />
                  </td>
                  <td>
                    <input
                      id="friday_finish_food"
                      type="time"
                      className="form-control"
                      value={entryData[0].friday_finish_food}
                    />
                  </td>
                  <td>
                    <input
                      id="saturday_finish_food"
                      type="time"
                      className="form-control"
                      value={entryData[0].saturday_finish_food}
                    />
                  </td>
                  <td>
                    <input
                      id="sunday_finish_food"
                      type="time"
                      className="form-control"
                      value={entryData[0].sunday_finish_food}
                    />
                  </td>
                </tr>
                <tr>
                  <td>A:</td>
                  <td>
                    <input
                      id="monday_finish"
                      type="time"
                      className="form-control"
                      value={entryData[0].monday_finish}
                    />
                  </td>
                  <td>
                    <input
                      id="tuesday_finish"
                      type="time"
                      className="form-control"
                      value={entryData[0].tuesday_finish}
                    />
                  </td>
                  <td>
                    <input
                      id="wednesday_finish"
                      type="time"
                      className="form-control"
                      value={entryData[0].wednesday_finish}
                    />
                  </td>
                  <td>
                    <input
                      id="thursday_finish"
                      type="time"
                      className="form-control"
                      value={entryData[0].thursday_finish}
                    />
                  </td>
                  <td>
                    <input
                      id="friday_finish"
                      type="time"
                      className="form-control"
                      value={entryData[0].friday_finish}
                    />
                  </td>
                  <td>
                    <input
                      id="saturday_finish"
                      type="time"
                      className="form-control"
                      value={entryData[0].saturday_finish}
                    />
                  </td>
                  <td>
                    <input
                      id="sunday_finish"
                      type="time"
                      className="form-control"
                      value={entryData[0].sunday_finish}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </form>
        </>
      );
      const result = await Swal.fire({
        title: "Editar Usuario Cooler",
        html: reactComponentHtml,
        showDenyButton: true,
        confirmButtonText: "Actualizar",
        denyButtonText: "Cancelar",
        width: 1500,
        didOpen: () => {
          attachLiveValidation();
        },
        padding: "1px",
        color: "#000",
        backdrop: `
                rgba(0,0,0,0.8)
            `,
        customClass: {
          confirmButton: "btn-amc-blue",
          denyButton: "btn-cancel",
          title: "alert-title",
          popup: "alert-bg",
        },
        preConfirm: function () {
          const first_name = document.getElementById("first_name").value;
          const middle_name = document.getElementById("middle_name").value;
          const last_name = document.getElementById("last_name").value;
          const number = document.getElementById("number").value;
          const is_coordinator =
            document.getElementById("is_coordinator").value;
          const area = document.getElementById("area").value;

          const monday_start = document.getElementById("monday_start").value;
          const tuesday_start = document.getElementById("tuesday_start").value;
          const wednesday_start =
            document.getElementById("wednesday_start").value;
          const thursday_start =
            document.getElementById("thursday_start").value;
          const friday_start = document.getElementById("friday_start").value;
          const saturday_start =
            document.getElementById("saturday_start").value;
          const sunday_start = document.getElementById("sunday_start").value;

          const monday_start_food =
            document.getElementById("monday_start_food").value;
          const tuesday_start_food =
            document.getElementById("tuesday_start_food").value;
          const wednesday_start_food = document.getElementById(
            "wednesday_start_food"
          ).value;
          const thursday_start_food = document.getElementById(
            "thursday_start_food"
          ).value;
          const friday_start_food =
            document.getElementById("friday_start_food").value;
          const saturday_start_food = document.getElementById(
            "saturday_start_food"
          ).value;
          const sunday_start_food =
            document.getElementById("sunday_start_food").value;

          const monday_finish_food =
            document.getElementById("monday_finish_food").value;
          const tuesday_finish_food = document.getElementById(
            "tuesday_finish_food"
          ).value;
          const wednesday_finish_food = document.getElementById(
            "wednesday_finish_food"
          ).value;
          const thursday_finish_food = document.getElementById(
            "thursday_finish_food"
          ).value;
          const friday_finish_food =
            document.getElementById("friday_finish_food").value;
          const saturday_finish_food = document.getElementById(
            "saturday_finish_food"
          ).value;
          const sunday_finish_food =
            document.getElementById("sunday_finish_food").value;

          const monday_finish = document.getElementById("monday_finish").value;
          const tuesday_finish =
            document.getElementById("tuesday_finish").value;
          const wednesday_finish =
            document.getElementById("wednesday_finish").value;
          const thursday_finish =
            document.getElementById("thursday_finish").value;
          const friday_finish = document.getElementById("friday_finish").value;
          const saturday_finish =
            document.getElementById("saturday_finish").value;
          const sunday_finish = document.getElementById("sunday_finish").value;

          let hasError = false;

          REQUIRED_FIELDS.forEach((id) => {
            const el = document.getElementById(id);
            if (!el || el.value.trim() === "") {
              markError(id);
              hasError = true;
            }
          });

          if (hasError) {
            Swal.showValidationMessage("Todos los campos son obligatorios");
            return false;
          }

          // if (
          //   !first_name ||
          //   !middle_name ||
          //   !last_name ||
          //   !number ||
          //   !is_coordinator ||
          //   !area
          // ) {
          //   Swal.showValidationMessage("Todos los campos son obligatorios");
          //   return false;
          // }

          return {
            first_name,
            middle_name,
            last_name,
            number,
            is_coordinator,
            area,
            monday_start,
            tuesday_start,
            wednesday_start,
            thursday_start,
            friday_start,
            saturday_start,
            sunday_start,
            monday_start_food,
            tuesday_start_food,
            wednesday_start_food,
            thursday_start_food,
            friday_start_food,
            saturday_start_food,
            sunday_start_food,
            monday_finish,
            tuesday_finish,
            wednesday_finish,
            thursday_finish,
            friday_finish,
            saturday_finish,
            sunday_finish,
            monday_finish_food,
            tuesday_finish_food,
            wednesday_finish_food,
            thursday_finish_food,
            friday_finish_food,
            saturday_finish_food,
            sunday_finish_food,
          };
        },
      });

      if (result.isConfirmed) {
        const updatedUserData = result.value;
        const updateResponse = await axios.put(
          `${process.env.REACT_APP_URL_BACKEND}/api/v1/cooler_users/update/${id}`,
          updatedUserData,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          }
        );

        Swal.fire(
          "¡Actualizado!",
          "El usuario ha sido actualizado exitosamente.",
          "success"
        );
        setUpdateTrigger(!updateTrigger);
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          "Cancelado",
          "No se ha realizado ninguna actualización.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error:", error); // Depuración
      Swal.fire("Error", "Hubo un error al actualizar", "error");
    }
  };

  const createEntries = async () => {
    try {
      const reactComponentHtml = ReactDOMServer.renderToString(
        <>
          <form
            acceptCharset="UTF-8"
            id="formValidation"
            className="form-horizontal fv-form fv-form-bootstrap"
            autoComplete="off"
            encType="multipart/form-data"
            noValidate="novalidate"
          >
            <div className="row mb-3 text-start">
              <div className="col-md-6">
                <label htmlFor="first_name">Nombre *</label>
                <input
                  type="text"
                  id="first_name"
                  class="form-control"
                  placeholder="Nombre"
                  oninput="this.value = this.value.replace(/[^a-zA-Z ]/g, '')"
                />
              </div>
              <div className="col-md-6">
                <label htmlFor="middle_name">Apellido paterno *</label>
                <input
                  type="text"
                  id="middle_name"
                  class="form-control"
                  placeholder="Apellido paterno"
                  oninput="this.value = this.value.replace(/[^a-zA-Z ]/g, '')"
                />
              </div>
              <div className="col-md-6">
                <label htmlFor="last_name">Apellido materno *</label>
                <input
                  type="text"
                  id="last_name"
                  class="form-control"
                  placeholder="Apellido materno"
                  oninput="this.value = this.value.replace(/[^a-zA-Z ]/g, '')"
                />
              </div>
              <div className="col-md-6">
                <label htmlFor="number">Número de empleado *</label>
                <input
                  type="text"
                  className="form-control"
                  id="number"
                  placeholder="Número de empleado"
                />
              </div>
              <div className="col-md-6">
                <label htmlFor="area">Área *</label>
                <select className="form-select" id="area">
                <option value="" selected disabled>Selecciona...</option>
                  <option value="1">Importación</option>
                  <option value="2">Exportación</option>
                </select>
              </div>
              <div className="col-md-6">
                <label htmlFor="is_coordinator">¿Es coordinador? *</label>
                <select className="form-select" id="is_coordinator">
                <option value="" selected disabled>Selecciona...</option>
                  <option value="1">Sí</option>
                  <option value="0">No</option>
                </select>
              </div>
            </div>

            <table className="table table-bordered">
              <thead className="thead-dark">
                <tr>
                  <th>Horario/Día</th>
                  <th>Lunes</th>
                  <th>Martes</th>
                  <th>Miércoles</th>
                  <th>Jueves</th>
                  <th>Viernes</th>
                  <th>Sábado</th>
                  <th>Domingo</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>De:</td>
                  <td>
                    <input
                      id="monday_start"
                      type="time"
                      className="form-control"
                    />
                  </td>
                  <td>
                    <input
                      id="tuesday_start"
                      type="time"
                      className="form-control"
                    />
                  </td>
                  <td>
                    <input
                      id="wednesday_start"
                      type="time"
                      className="form-control"
                    />
                  </td>
                  <td>
                    <input
                      id="thursday_start"
                      type="time"
                      className="form-control"
                    />
                  </td>
                  <td>
                    <input
                      id="friday_start"
                      type="time"
                      className="form-control"
                    />
                  </td>
                  <td>
                    <input
                      id="saturday_start"
                      type="time"
                      className="form-control"
                    />
                  </td>
                  <td>
                    <input
                      id="sunday_start"
                      type="time"
                      className="form-control"
                    />
                  </td>
                </tr>
                <tr>
                  <td>Inicio de comida:</td>
                  <td>
                    <input
                      id="monday_start_food"
                      type="time"
                      className="form-control"
                    />
                  </td>
                  <td>
                    <input
                      id="tuesday_start_food"
                      type="time"
                      className="form-control"
                    />
                  </td>
                  <td>
                    <input
                      id="wednesday_start_food"
                      type="time"
                      className="form-control"
                    />
                  </td>
                  <td>
                    <input
                      id="thursday_start_food"
                      type="time"
                      className="form-control"
                    />
                  </td>
                  <td>
                    <input
                      id="friday_start_food"
                      type="time"
                      className="form-control"
                    />
                  </td>
                  <td>
                    <input
                      id="saturday_start_food"
                      type="time"
                      className="form-control"
                    />
                  </td>
                  <td>
                    <input
                      id="sunday_start_food"
                      type="time"
                      className="form-control"
                    />
                  </td>
                </tr>
                <tr>
                  <td>Fin de comida:</td>
                  <td>
                    <input
                      id="monday_finish_food"
                      type="time"
                      className="form-control"
                    />
                  </td>
                  <td>
                    <input
                      id="tuesday_finish_food"
                      type="time"
                      className="form-control"
                    />
                  </td>
                  <td>
                    <input
                      id="wednesday_finish_food"
                      type="time"
                      className="form-control"
                    />
                  </td>
                  <td>
                    <input
                      id="thursday_finish_food"
                      type="time"
                      className="form-control"
                    />
                  </td>
                  <td>
                    <input
                      id="friday_finish_food"
                      type="time"
                      className="form-control"
                    />
                  </td>
                  <td>
                    <input
                      id="saturday_finish_food"
                      type="time"
                      className="form-control"
                    />
                  </td>
                  <td>
                    <input
                      id="sunday_finish_food"
                      type="time"
                      className="form-control"
                    />
                  </td>
                </tr>
                <tr>
                  <td>A:</td>
                  <td>
                    <input
                      id="monday_finish"
                      type="time"
                      className="form-control"
                    />
                  </td>
                  <td>
                    <input
                      id="tuesday_finish"
                      type="time"
                      className="form-control"
                    />
                  </td>
                  <td>
                    <input
                      id="wednesday_finish"
                      type="time"
                      className="form-control"
                    />
                  </td>
                  <td>
                    <input
                      id="thursday_finish"
                      type="time"
                      className="form-control"
                    />
                  </td>
                  <td>
                    <input
                      id="friday_finish"
                      type="time"
                      className="form-control"
                    />
                  </td>
                  <td>
                    <input
                      id="saturday_finish"
                      type="time"
                      className="form-control"
                    />
                  </td>
                  <td>
                    <input
                      id="sunday_finish"
                      type="time"
                      className="form-control"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </form>
        </>
      );

      const result = await Swal.fire({
        title: "Agregar Usuario Cooler",
        html: reactComponentHtml,
        showDenyButton: true,
        confirmButtonText: "Guardar",
        denyButtonText: "Cancelar",
        width: 1500,
        didOpen: () => {
          attachLiveValidation();
        },
        padding: "1px",
        color: "#000",
        backdrop: `
                  rgba(0,0,0,0.8)
              `,
        customClass: {
          confirmButton: "btn-amc-blue",
          denyButton: "btn-cancel",
          title: "alert-title",
          popup: "alert-bg",
        },
        preConfirm: function () {
          const fields = [
            "first_name",
            "middle_name",
            "last_name",
            "number",
            "is_coordinator",
            "area",
            "monday_start",
            "tuesday_start",
            "wednesday_start",
            "thursday_start",
            "friday_start",
            "saturday_start",
            "sunday_start",
            "monday_start_food",
            "tuesday_start_food",
            "wednesday_start_food",
            "thursday_start_food",
            "friday_start_food",
            "saturday_start_food",
            "sunday_start_food",
            "monday_finish",
            "tuesday_finish",
            "wednesday_finish",
            "thursday_finish",
            "friday_finish",
            "saturday_finish",
            "sunday_finish",
            "monday_finish_food",
            "tuesday_finish_food",
            "wednesday_finish_food",
            "thursday_finish_food",
            "friday_finish_food",
            "saturday_finish_food",
            "sunday_finish_food",
          ];

          const data = {};

          fields.forEach((field) => {
            const value = document.getElementById(field).value;
            if (value !== "") {
              data[field] = value;
            }
          });

          let hasError = false;

          REQUIRED_FIELDS.forEach((id) => {
            const el = document.getElementById(id);
            if (!el || el.value.trim() === "") {
              markError(id);
              hasError = true;
            }
          });

          if (hasError) {
            Swal.showValidationMessage("Todos los campos son obligatorios");
            return false;
          }

          // if (
          //   !data.first_name ||
          //   !data.middle_name ||
          //   !data.last_name ||
          //   !data.number ||
          //   !data.is_coordinator ||
          //   !data.area
          // ) {
          //   Swal.showValidationMessage("Todos los campos son obligatorios");
          //   return false;
          // }

          return data;
        },
      });

      if (result.isConfirmed) {
        const Data = result.value;

        const createResponse = await axios.post(
          `${process.env.REACT_APP_URL_BACKEND}/api/v1/cooler_users/create`,
          Data,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          }
        );

        Swal.fire(
          "¡Creado!",
          "El usuario ha sido registrado exitosamente.",
          "success"
        );
        setUpdateTrigger(!updateTrigger);
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Cancelado", "Acción cancelada.", "error");
      }
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Hubo un error", "error");
    }
  };

  const handleSearch = () => {
    const input = document.getElementById("searchInput");
    setSearchValue(input.value.trim());
  };

  useEffect(() => {
    getEntries();
  }, [updateTrigger]);

  return (
    <>
      <Helmet>
        <title>Horus | Usuarios Cooler</title>
      </Helmet>
      <ScrollToTop />
      <div className="table-responsive">
        <div
          className="dataTables_wrapper dt-bootstrap4 no-footer container-fluid"
          id="datatables_wrapper"
        >
          <div className="text-right mb-2 ">
            <button
              className="btnn"
              onClick={() => setShowDeleted(!showDeleted)}
            >
              {showDeleted ? "Ver Activos" : "Ver Eliminados"}
            </button>
          </div>
          {showDeleted ? (
            <DeletedCoolerUsers
              setUpdateTrigger={setUpdateTrigger}
              updateTrigger={updateTrigger}
            />
          ) : (
            <>
              <div className="text-right mb-4 ">
                <button className="btnn" onClick={createEntries}>
                  Añadir Usuarios Cooler
                </button>
              </div>
              <div className="row justify-content-between mb-2">
                <div className="col-sm-12 col-md-4">
                  <div
                    className="dataTables_length mb-2"
                    id="dataTables_length"
                  >
                    <label className="d-flex justify-content-start">
                      <span className="mr-2 p-2">Mostrar</span>
                      <select
                        name="datatables_length"
                        aria-controls="datatables_length"
                        className="custom-select custom-select-sm form-control-sm narrow-select p-2"
                        onChange={showEntries}
                      >
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                      </select>
                      <span className="ml-2 p-2">registros</span>
                    </label>
                  </div>
                </div>
                <div className="col-sm-12 col-md-4">
                  <div className="datatables_filter" id="datatables_filter">
                    <label className="d-flex justify-content-end">
                      <input
                        type="search"
                        id="searchInput"
                        className="form-control form-control-sm"
                        placeholder="Buscar..."
                        aria-controls="datatables"
                      />
                      <button className="btnn" onClick={handleSearch}>
                        Buscar
                      </button>
                    </label>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <table
                    className="table table-inverse table-hover table-striped table-bordered dataTable no-footer"
                    role="grid"
                    aria-describedby="datatables_info"
                  >
                    <thead>
                      <tr role="row">
                        <th
                          className="sorting"
                          tabIndex={0}
                          aria-controls="datatables"
                          rowSpan={1}
                          colSpan={1}
                          style={{ width: "343.25px" }}
                        >
                          Nombre
                        </th>
                        <th
                          className="sorting"
                          tabIndex={0}
                          aria-controls="datatables"
                          rowSpan={1}
                          colSpan={1}
                          style={{ width: "343.25px" }}
                        >
                          Apellido paterno
                        </th>
                        <th
                          className="sorting"
                          tabIndex={0}
                          aria-controls="datatables"
                          rowSpan={1}
                          colSpan={1}
                          style={{ width: "343.25px" }}
                        >
                          Apellido materno
                        </th>
                        <th
                          className="sorting"
                          tabIndex={0}
                          aria-controls="datatables"
                          rowSpan={1}
                          colSpan={1}
                          style={{ width: "343.25px" }}
                        >
                          Número de empleado
                        </th>
                        <th
                          className="sorting"
                          tabIndex={0}
                          aria-controls="datatables"
                          rowSpan={1}
                          colSpan={1}
                          style={{ width: "343.25px" }}
                        >
                          ¿Es coordinador?
                        </th>
                        <th
                          className="sorting"
                          tabIndex={0}
                          aria-controls="datatables"
                          rowSpan={1}
                          colSpan={1}
                          style={{ width: "343.25px" }}
                        >
                          Creado
                        </th>
                        <th
                          className="sorting"
                          tabIndex={0}
                          aria-controls="datatables"
                          rowSpan={1}
                          colSpan={1}
                          style={{ width: "81.2031px" }}
                        >
                          Acciones
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentData.map((entry) => (
                        <tr key={entry.id} data-master-id={entry.id}>
                          <td>{entry.first_name}</td>
                          <td>{entry.middle_name}</td>
                          <td>{entry.last_name}</td>
                          <td>{entry.number}</td>
                          <td>{entry.is_coordinator == 1 ? "Sí" : "No"}</td>
                          <td>
                            <ReactTimeAgo date={entry.created_at} locale="es" />
                          </td>
                          <td>
                            <FaEdit
                              className="editButton"
                              onClick={() => {
                                updateEntries(entry.id);
                              }}
                            />
                            <FaTimes
                              className="deleteButton"
                              onClick={() => {
                                deleteEntries(entry.id);
                              }}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="row">
                <nav aria-label="Page navigation example">
                  <ul className="pagination">
                    <li className="page-item">
                      <button
                        className="page-link"
                        onClick={() => paginate(currentPage - 1)}
                        disabled={currentPage === 1}
                      >
                        Anterior
                      </button>
                    </li>
                    {pageNumbers.map((pageNumber) => (
                      <li className="page-item" key={pageNumber}>
                        <button
                          className="page-link"
                          onClick={() => paginate(pageNumber)}
                        >
                          {pageNumber}
                        </button>
                      </li>
                    ))}
                    <li className="page-item">
                      <button
                        className="page-link"
                        onClick={() => paginate(currentPage + 1)}
                        disabled={currentPage === pageNumbers.length}
                      >
                        Siguiente
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}

export default CoolerUsers;
